import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import { getGlobalVariableSelector } from '@store/global-variables';
import { BasketService, EventsService } from '@services';
import { Checkbox, Icon, Popup } from '@elements';
import { i18n } from '@localization';
import { StyledContent, StyledHeader, StyledPopup } from './pay-back.styles';
import logo from '@images/logo-big.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PayBackPopup = function PayBackPopup(_ref) {
  var _filterByBasket$filte;

  var rejectPopup = _ref.rejectPopup,
      popUp = _ref.popUp;
  var header = popUp && popUp.data && popUp.data.header; // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access

  var eventInfo = popUp && popUp.data && popUp.data.data.eventInfo;
  var basket = useSelector(getGlobalVariableSelector('basket'));
  var filterByBasket = EventsService.getBuyBackCache();
  return /*#__PURE__*/_jsxs(StyledPopup, {
    width: 480,
    fullWidth: true,
    popUp: popUp,
    children: [/*#__PURE__*/_jsx(Popup.Title, {
      children: /*#__PURE__*/_jsx(StyledHeader, {
        children: /*#__PURE__*/_jsx(Icon, {
          src: logo,
          width: 88,
          height: 88
        })
      })
    }), /*#__PURE__*/_jsx(Popup.Content, {
      children: /*#__PURE__*/_jsxs(StyledContent, {
        flexDirection: "column",
        pt: 3,
        children: [header && /*#__PURE__*/_jsx(Typography, {
          color: "#FFF",
          variant: "h4",
          textAlign: "center",
          children: header
        }), /*#__PURE__*/_jsxs(Box, {
          width: "100%",
          children: [/*#__PURE__*/_jsx(Box, {
            children: /*#__PURE__*/_jsx(Typography, {
              color: "#FFF",
              variant: "h4",
              textAlign: "center",
              children: i18n.t('components.popups.buyBack.description')
            })
          }), filterByBasket === null || filterByBasket === void 0 ? void 0 : (_filterByBasket$filte = filterByBasket.filter(function (item) {
            return !item.ga;
          })) === null || _filterByBasket$filte === void 0 ? void 0 : _filterByBasket$filte.map(function (item) {
            var _item$locationSchemeS, _item$locationSchemeS2, _item$locationSchemeS3, _item$locationSchemeS4, _item$prefix, _item$name;

            var inBasket = basket.find(function (basketItem) {
              return basketItem.locationSchemeSeatId === item.id;
            });
            return /*#__PURE__*/_jsx(Box, {
              pt: 2,
              width: "100%",
              justifyContent: "flex-start",
              children: /*#__PURE__*/_jsx(Checkbox, {
                onClick: function onClick() {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  if (inBasket) {
                    var _eventInfo$uuid;

                    BasketService.unreserveSeat([{
                      eventSessionUuid: (_eventInfo$uuid = eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.uuid) !== null && _eventInfo$uuid !== void 0 ? _eventInfo$uuid : '',
                      locationSchemeSeats: [{
                        categoryId: Number(process.env.adultCategoryId),
                        locationSchemeSeatId: item.id,
                        quantity: 1
                      }]
                    }]).then(function (basketResp) {
                      BasketService.updateStoreFromResponse(basketResp);
                    })["catch"](function () {// error handling
                    });
                  } else {
                    var _eventInfo$uuid2;

                    BasketService.reserveSeat({
                      categoryId: Number(process.env.adultCategoryId),
                      eventSessionUuid: (_eventInfo$uuid2 = eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.uuid) !== null && _eventInfo$uuid2 !== void 0 ? _eventInfo$uuid2 : '',
                      locationSchemeSeatIds: [item.id],
                      quantity: 1
                    }).then(function (basketResp) {
                      BasketService.updateStoreFromResponse(basketResp);
                    })["catch"](function (error) {// catch error
                    });
                  }
                } // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                ,
                checked: inBasket // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                ,
                label: /*#__PURE__*/_jsx(Typography, {
                  color: "#FFF",
                  variant: "h4",
                  textAlign: "center",
                  children: "".concat((_item$locationSchemeS = item.locationSchemeSeatsOutgroupPrefix) !== null && _item$locationSchemeS !== void 0 ? _item$locationSchemeS : '', " ").concat((_item$locationSchemeS2 = item.locationSchemeSeatsOutgroupName) !== null && _item$locationSchemeS2 !== void 0 ? _item$locationSchemeS2 : '', " ").concat((_item$locationSchemeS3 = item.locationSchemeSeatsIngroupPrefix) !== null && _item$locationSchemeS3 !== void 0 ? _item$locationSchemeS3 : '', " ").concat((_item$locationSchemeS4 = item.locationSchemeSeatsIngroupName) !== null && _item$locationSchemeS4 !== void 0 ? _item$locationSchemeS4 : '', " ").concat((_item$prefix = item.prefix) !== null && _item$prefix !== void 0 ? _item$prefix : '', " ").concat((_item$name = item.name) !== null && _item$name !== void 0 ? _item$name : '')
                })
              })
            }, item.id);
          })]
        })]
      })
    })]
  });
};

export { PayBackPopup };